let arrow, target;
jQuery(document).ready(function(){
    arrow = jQuery('#goup');
    target = jQuery('#up')
    jQuery(window).scroll(checkArrow);
})

function checkArrow(){
    let body = document.body, html = document.documentElement;
    let height = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
    let scrollTop = jQuery(window).scrollTop();
    if(scrollTop>(height/10) && height>jQuery(window).outerHeight(true)*2) arrow.addClass('appear');
    else arrow.removeClass('appear');
}